import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-position",
  "use": "icon-position-usage",
  "viewBox": "0 0 11 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 14\" id=\"icon-position\"><path d=\"M5.256.008A5.25 5.25 0 0 0 0 5.253c0 2.897 5.255 8.741 5.255 8.741s5.255-5.844 5.255-8.74A5.25 5.25 0 0 0 5.256.007zm3.153 5.245A3.15 3.15 0 0 1 5.256 8.4a3.15 3.15 0 0 1-3.153-3.147 3.15 3.15 0 0 1 3.153-3.147 3.15 3.15 0 0 1 3.153 3.147z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol